// extracted by mini-css-extract-plugin
export var postLink = "PostLink-module--postLink--W2uLk";
export var image = "PostLink-module--image--GlMTI";
export var arrow = "PostLink-module--arrow--URS2g";
export var imageClass = "PostLink-module--imageClass--Evvan";
export var textArea = "PostLink-module--textArea--IJS2I";
export var titleClass = "PostLink-module--titleClass--GjKGS";
export var dateClass = "PostLink-module--dateClass--BwFtU";